import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import { BrowserRouter, useLocation, Routes, Route } from "react-router-dom";
import { initializeGA, trackPageView } from "./analytics";
import './instrument';
import * as Sentry from "@sentry/react";

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

// Initialize Google Analytics
initializeGA();

// Track page views on route changes
const TrackPageView = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);
  return null;
};

// App wrapper for routing
const AppWithTracking = () => (
  <>
    <TrackPageView />
    <Routes>
      <Route path="/*" element={<App />} />
    </Routes>
  </>
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppWithTracking />
    </BrowserRouter>
  </React.StrictMode>
);

// Polyfill for globalThis (optional)
(function () {
  try {
    let e = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
    if (typeof globalThis === "undefined") {
      Object.defineProperty(e, 'globalThis', {
        configurable: true,
        enumerable: false,
        writable: true,
        value: e
      });
    }
    const n = new e.Error().stack;
    if (n) {
      e._sentryDebugIds = e._sentryDebugIds || {};
      e._sentryDebugIds[n] = "dfb8cca9-af15-5423-a3a1-10bc0eb6c820";
    }
  } catch (e) {
    console.error('An error occurred while setting up globalThis polyfill:', e);
  }
})();
